import { useForm } from "antd/es/form/Form";
import { DatePicker, Form, message } from "antd";
import moment from "moment";
import K from "../../../../../../utilities/constants";
import {
  dateWithCurrentTime,
  restrictDateToRange,
} from "../../../../../../utilities/dateUtility";
import { useFormDirty } from "../../../../../../hooks/useFormDirty";
import { Modal } from "../../../../../../common/components/modal/modal";

export const EditStartDateModal = ({
  open,
  loading,
  onCancel,
  lastRuleStartDate,
  startDate,
  onFinish,
}) => {
  const [form] = useForm();

  const initialValues = { startDate: moment.unix(startDate) };

  const [isDirty, onValuesChange] = useFormDirty(form, initialValues);

  const handleFinish = (values) => {
    onFinish({ ...values, startDate: dateWithCurrentTime(values.startDate) });
  };

  return (
    <Modal
      open={open}
      title="Edit Start Date"
      onOk={form.submit}
      onCancel={onCancel}
      okButtonProps={{ disabled: !isDirty, loading }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onValuesChange={(_, values) => onValuesChange(values)}
        onFinish={handleFinish}
      >
        <Form.Item
          label="Start Date"
          name="startDate"
          rules={[{ required: true, message: "Please select start date!" }]}
        >
          <DatePicker
            format={K.DateFormat.DashUSFormat}
            disabledDate={restrictDateToRange(
              moment.unix(lastRuleStartDate),
              moment(),
            )}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
